<template>
  <div class="thank-you-container">
    <div class="content-wrapper">
      <svg class="checkmark-icon" viewBox="0 0 52 52">
        <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
        <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
      </svg>
      <h1 class="title">Proposal Accepted!</h1>
      <p class="subtitle">Thanks for accepting this proposal. We are looking forward to working with you.<br><br>A contract to formalise our engagement will be sent to you via email shortly.</p>
    </div>
    
    <a href="https://vertexcybersecurity.com.au" class="logo-link">
      <img :src="logo" alt="Vertex Cyber Security Logo" class="logo">
    </a>

  </div>
</template>

<script>
import vertexLogo from '@/assets/img/vertex_logo.png';

export default {
  name: 'ProposalThankYouPage',
  data() {
    return {
      logo: vertexLogo,
    };
  },

   mounted() {
      // Track the PageView event for this specific form
      if (window.fbq) {
         window.fbq('track', 'PageView');
      }
   },
};
</script>

<style scoped>
/* Import the Roboto font from Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

.thank-you-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-image: url("~@/assets/img/BG_Mountain.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* Apply Roboto font to the entire container */
  font-family: 'Roboto', sans-serif;
  text-align: center;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 40px 60px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.checkmark-icon {
  width: 80px;
  height: 80px;
  stroke-width: 3;
  stroke: #00a0c1;
  stroke-miterlimit: 10;
  box-shadow: 0 0 20px rgba(0, 160, 193, 0.4);
  border-radius: 50%;
  animation: check-fade-in 1s ease-in-out forwards;
}

.checkmark-circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 3;
  stroke-miterlimit: 10;
  stroke: #00a0c1;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark-check {
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

.title {
  font-size: 2.5rem;
  font-weight: 500;
  color: #333; /* Dark color for title */
  margin: 20px 0 10px;
  opacity: 0;
  animation: fade-in 1s ease-in-out 1.2s forwards;
}

.subtitle {
  font-size: 1.2rem;
  color: #555; /* Slightly lighter dark color for subtitle */
  margin-top: 0;
  opacity: 0;
  animation: fade-in 1s ease-in-out 1.5s forwards;
  max-width: 600px;
}

.logo-link {
  display: inline-block;
  /* Ensures the link respects the animation of the image inside */
  text-decoration: none; 
}

.logo {
  max-width: 250px;
  opacity: 0;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 5px 10px;
  animation: fade-in 1s ease-in-out 1.8s forwards;

  cursor: pointer; 
  transition: transform 0.2s;
}

.logo:hover {
  transform: scale(1.05);
  background-color: rgba(255, 255, 255, 0.2);
}

/* Animations */
@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes check-fade-in {
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: scale(1); }
}
</style>